/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Combo_Component_Not_FoundInputs */

const vi_error_combo_component_not_found = /** @type {(inputs: Error_Combo_Component_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Một thành phần trong công thức không còn tồn tại. Xoá dòng đó rồi lưu lại.`)
};

/**

* @param {Error_Combo_Component_Not_FoundInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_combo_component_not_found = /** @type {((inputs?: Error_Combo_Component_Not_FoundInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Combo_Component_Not_FoundInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_combo_component_not_found(inputs)
});